import { render, staticRenderFns } from "./TenantConfigList.vue?vue&type=template&id=78691746&scoped=true"
import script from "./TenantConfigList.vue?vue&type=script&lang=js"
export * from "./TenantConfigList.vue?vue&type=script&lang=js"
import style0 from "./TenantConfigList.vue?vue&type=style&index=0&id=78691746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78691746",
  null
  
)

export default component.exports